import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getAssociation } from "../services/association";
import { useLocale } from "../stores/locale";

export function useGetAssociation(id: string) {
  const { currentLanguage } = useLocale();

  return useQuery({
    queryKey: ["associations", id, currentLanguage],
    queryFn: () => getAssociation(currentLanguage, id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
